/**
 * API endpoint configuration
 */
// import {baseUrlApis,jaegerApi} from '../index';
// // easy-mock mock API endpoints
// const MOCK_API = 'https://react-admin-mock.yezihaohao.now.sh/api';
// export const MOCK_AUTH_ADMIN = MOCK_API + '/admin.js'; // Admin permission API
// export const MOCK_AUTH_VISITOR = MOCK_API + '/visitor.js'; // Visitor permission API

// // GitHub OAuth
// export const GIT_OAUTH = 'https://github.com/login/oauth';
// // GitHub user
// export const GIT_USER = 'https://api.github.com/user';

// // bbc top news
// export const NEWS_BBC =
//     'https://newsapi.org/v2/top-headlines?sources=bbc-news&apiKey=429904aa01f54a39a278a406acf50070';

// https://8.newspush.eastmoney.com/sse?cb=icomet_cb_0&cname=bdc02c361aab973818f3583fb8b5e6d5&seq=0&noop=0&token=&_=1605148069461
// API
// export const GET_newspush = baseUrl + '/sse';

// console.log("process.env.NODE_ENV", process.env.NODE_ENV)

// const serverConfigs = await baseUrlApis.getServerConfig();
let templateApiUrl = (process.env.NODE_ENV === 'development')?'https://template-azk8s.foxitcloud.com':window.location.origin;

export const GET_category = templateApiUrl + '/api/template/category';
export const GET_templateList = templateApiUrl + '/api/template/lists';
export const GET_templateUlists = templateApiUrl + '/api/template/ulists';
export const GET_templateSearch = templateApiUrl + '/api/template/search';
export const POST_templateUse = templateApiUrl + '/api/template/use';
export const GET_templateDownload = templateApiUrl + '/api/file/download';
export const GET_templateInfo = templateApiUrl + '/api/template';
export const GET_clicks_rank = templateApiUrl + '/api/template/clicks-rank';
export const POST_comment = templateApiUrl + '/api/template/comment';
export const POST_template_clicks = templateApiUrl + '/api/template/clicks';